export const SHORT_WEEK_DAYS = [
  'seg',
  'ter',
  'qua',
  'qui',
  'sex',
  'sab',
  'dom',
];

export const WEEK_DAYS = [
  'Segunda',
  'Terça',
  'Quarta',
  'Quinta',
  'Sexta',
  'Sábado',
  'Domingo',
];

export const LONG_WEEK_DAYS = [
  'Segunda-feira',
  'Terça-feira',
  'Quarta-feira',
  'Quinta-feira',
  'Sexta-feira',
  'Sábado',
  'Domingo',
];

export const RESPONSIVE_WEEK_DAYS: { [breakpoint: string]: string[][] } = {
  full: [['seg', 'ter', 'qua', 'qui', 'sex', 'sab', 'dom']],
  xxxl: [
    ['seg', 'ter', 'qua', 'qui', 'sex'],
    ['ter', 'qua', 'qui', 'sex', 'sab'],
    ['qua', 'qui', 'sex', 'sab', 'dom'],
  ],
  xxl: [
    ['seg', 'ter', 'qua', 'qui'],
    ['ter', 'qua', 'qui', 'sex'],
    ['qua', 'qui', 'sex', 'sab'],
    ['qui', 'sex', 'sab', 'dom'],
  ],
  xl: [
    ['seg', 'ter'],
    ['ter', 'qua'],
    ['qua', 'qui'],
    ['qui', 'sex'],
    ['sex', 'sab'],
    ['sab', 'dom'],
  ],
  lg: [['seg'], ['ter'], ['qua'], ['qui'], ['sex'], ['sab'], ['dom']],
};

export const CURRENT_ORDER_LOCAL_STORAGE_KEY = '@AtacDelivery:currentOrder';
